export default function useHazardOrWarningOptions() {
	return [
		{ key: "00", value: "00", text: "No known hazards or warnings" },
		{ key: "13", value: "13", text: "WARNING – Flashing hazard" },
		{ key: "14", value: "14", text: "No flashing hazard warning necessary" },
		{ key: "15", value: "15", text: "WARNING – Sound hazard" },
		{ key: "16", value: "16", text: "No sound hazard warning necessary" },
		{ key: "17", value: "17", text: "WARNING – Motion simulation hazard" },
		{ key: "18", value: "18", text: "No motion simulation hazard warning necessary" },
	];
}
